import { imgResize } from './imgResize'
import { init } from './init'

export const swiper = {
  init,
  imgResize,
}


// WEBPACK FOOTER //
// ./js/animation/swiper/index.js